var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { AgeCategoryService } from "../../../services/ageCategory/ageCategory.service";
export var useAllAgeCategories = function () {
    var _a;
    var query = useQuery('allAgeCategories', function () {
        return AgeCategoryService.getAllAgeCategories({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useAgeCategories = function (ids) {
    var _a;
    var idsSorted = __spreadArray([], ids, true).sort(function (a, b) { return a.localeCompare(b); });
    var query = useQuery(['ageCategories', idsSorted], function () {
        return AgeCategoryService.getAllAgeCategories({
            id: idsSorted,
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
